module.exports = __webpack_public_path__ + "static/media/404.e31177d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/404.png
// module id = 958
// module chunks = 0